import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const InnovatorsConfirmed = () => {
  const q = new URLSearchParams(useLocation().search);
  const sessionId = q.get("session_id");
  const [state, setState] = useState("loading");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    axios.get(`${API}/innovators/confirm/${sessionId}`)
      .then((r) => { setData(r.data); setState("done"); })
      .catch(() => setState("error"));
  }, [sessionId]);

  return (
    <div className="bg-[#2c6052] min-h-screen text-[#f3ece1] flex flex-col items-center justify-center px-6 text-center py-20">
      {state === "loading" && <p className="text-[#c9bcab]">Confirming your place…</p>}
      {state === "error" && (
        <>
          <h1 className="feral-serif text-4xl text-[#f0dbbe] mb-3">We couldn't confirm that</h1>
          <p className="text-[#c9bcab] max-w-md">If you completed payment, your place is safe and you'll get a confirmation email. Otherwise please try your invitation link again.</p>
        </>
      )}
      {state === "done" && (
        <div data-testid="confirmed" className="max-w-lg">
          <div className="w-16 h-16 rounded-full bg-[#2a3a24] text-[#9fd089] flex items-center justify-center mx-auto mb-5"><Check size={30} /></div>
          <h1 className="feral-serif text-5xl text-[#f0dbbe] mb-4">You're in.</h1>
          <p className="text-[#d8cabb] leading-relaxed mb-2">Your place at the first FERAL Innovators is confirmed.</p>
          <p className="text-[#f0dbbe] leading-relaxed mb-2">Tuesday 10 November · Arrival from 5:45pm · Bron Menai Manor</p>
          {data?.accommodation_label && <p className="text-[#c9bcab] text-sm mb-2">Overnight stay booked: {data.accommodation_label}</p>}
          <p className="text-[#c9bcab] leading-relaxed mb-8">We'll send you everything you need before the evening. For now, just come curious.</p>
          <Link to="/" className="inline-block bg-[#ebc754] hover:bg-[#b9772c] text-[#1b1512] font-bold tracking-[0.1em] uppercase text-sm px-8 py-4 transition-colors">Back to FERAL</Link>
        </div>
      )}
    </div>
  );
};

export default InnovatorsConfirmed;
